<template>
    <div id="product-categories" class="container">
        <transition-group name="list" class="row py-5" tag="div">
            <div :id="`product-categories-item-${i + 1}`" class="col-md-4" :class="{'-disabled': product.disabled, '-hide': !!+photo.not_for_digital_sale && !!+product.isDownloadable}" v-for="(product, i) in processedProducts" :key="`index-${i}`"><!--v-show="cards[i].show"-->
                <div v-show="product.disabled" class="bk-card-label-wrap">
                  <div :id="`label-disabled-${i}`" class="bk-card-label">
                    {{ $t('disabled') }}
                  </div>
                  <b-tooltip placement="bottom" :target="`label-disabled-${i}`">
                    {{ $t('helpers.disabled_photo_in_product') }}
                  </b-tooltip>
                </div>
                <div class="bk-card-wrap">
                    <a href="#" :class="['bk-card', {'bk-card--disabled': !!+photo.not_for_digital_sale && !!+product.isDownloadable}]"
                       @click.prevent="next(product.id)">
                        <span class="bk-card-img"
                              :style="{backgroundImage: `url(${product.images && !!product.images.length  ? _.first(product.images).thumb : ''})`}">
                            <img v-if="product.images && !!product.images.length" :src="_.first(product.images).thumb" class="d-none">
                            <img v-else :src="require(`@/templates/${coreParams.theme_name}/assets/no-preview.jpg`)">
                            <!--<span v-if="i === processedProducts.length - 1" class="bk-card-discount">-20%</span>-->
                        </span>
                        <span class="bk-card-body bk-card-body--icon">
                            <span class="bk-card-title d-block clearfix">
                                {{ product.name || '&nbsp;' }}
                            </span>
                            <span class="bk-card-text" v-if="product.description" v-html="$options.filters.truncate(striptags(product.description), 30)"></span>
                            <span class="bk-card-text" v-else>&nbsp;</span>
                        </span>
                    </a>
                    <a href="#" @click.prevent="viewProductCategory(product)" class="bk-card-tooltip">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 210 210">
                            <path d="M601,233A105,105,0,1,0,706,338,105,105,0,0,0,601,233Zm0,189.68A84.68,84.68,0,1,1,685.68,338,84.63,84.63,0,0,1,601,422.68Z"
                                  transform="translate(-496 -233)"/>
                            <path d="M601,279.57a17.78,17.78,0,1,1-17.78,17.78A17.78,17.78,0,0,1,601,279.57Z"
                                  transform="translate(-496 -233)"/>
                            <path d="M624.71,387.11a5.08,5.08,0,0,1-5.08,5.08H582.37a5.08,5.08,0,0,1-5.08-5.08V377a5.08,5.08,0,0,1,5.08-5.08h5.08v-27.1h-5.08a5.08,5.08,0,0,1-5.08-5.08V329.53a5.08,5.08,0,0,1,5.08-5.08h27.1a5.08,5.08,0,0,1,5.08,5.08v42.34h5.08a5.08,5.08,0,0,1,5.08,5.08v10.16Z"
                                  transform="translate(-496 -233)"/>
                        </svg>
                    </a>
                </div>
            </div>
        </transition-group>
    </div>
</template>

<style lang="scss" scoped>
    .-hide {
        display: none;
    }

    .-disabled .bk-card-wrap {
        opacity: .3;
        pointer-events: none;
    }

    .list-enter-active, .list-leave-active {
        transition: opacity .5s;
    }

    .list-enter, .list-leave-to {
        opacity: 0;
    }
</style>

<script>
  import orderStep2 from 'src/mixins/orderStep2Component';

  export default {
    mixins: [orderStep2],
  };
</script>